// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"BaseRadioButton_input-wrapper_Kv1w6"};